// eslint-disable-next-line import/prefer-default-export
export const loginDetailsSelector = (state) => state.app.loginDetails;
export const getUserDetailsSelector = (state) => state.app.userDetails;
export const getMenuDetailsSelector = (state) => state.app.menuDetails;
export const getCompanyDetailsSelector = (state) => state.app.companyDetails;
export const profileImageDetailsSelector = (state) =>
  state.app.profileImageDetails;
export const getRoleAccessDetailsSelector = (state) =>
  state.app.roleAccessDetails;
export const getRoleAccessKeySelector = (state) => state.app.roleAccessKey;
export const getFeatureListSelector = (state) => state.app.featureList
export const getAccountList = (state) => state.app.accountList;
